import DialogModal from 'components/modal/dialog-modal';
import { useGetMeQuery } from 'redux-store/api/auth';
import { IAudienceSelectionDialog } from './types';
import { AudienceOptionList } from './components/audience-option-list';

import { PostVisibilityEnum } from 'redux-store/api/activity-feed';
import { DialogContainer } from '../shared/dialog';
import SpecificUsersList from './components/specific-users-list';
import { AudienceSelectionDialogHeader } from './components/audience-selection-dialog-header';
import { AudienceSelectionDialogFooter } from './components/audience-selection-dialog-footer';

export const AudienceSelectionDialog = ({
  projectId,
  activeAudience,
  availableAudiences,
  availableProfiles,
  onSetAudienceMembers,
  onSetAudienceToDelete,
  onSetActiveAudience,
  onOpenCustomAudience,
  onCancelSelection,
  onSaveSelection,
}: IAudienceSelectionDialog) => {
  const { data: userMe } = useGetMeQuery();

  const { postVisibility, customUsers = [], byRole = [], customGroups = [] } = activeAudience || {};

  const canDone =
    [customUsers, byRole, customGroups].some((arr) => arr.length) ||
    [PostVisibilityEnum.JUST_ME, PostVisibilityEnum.EVERYONE].includes(postVisibility);

  const specificUsersProfiles = availableProfiles?.filter(({ id }) => id !== userMe.id);

  return (
    <DialogModal open={true} withoutPadding maxWidth="650px" handleClose={onCancelSelection}>
      <AudienceSelectionDialogHeader />
      <DialogContainer additionalSx={{ gap: '20px' }}>
        <AudienceOptionList
          projectId={projectId}
          availableAudiences={availableAudiences}
          availableProfiles={availableProfiles}
          activeAudience={activeAudience}
          onSetActiveAudience={onSetActiveAudience}
          onSetAudienceMembers={onSetAudienceMembers}
          onSetAudienceToDelete={onSetAudienceToDelete}
          onOpenCustomAudienceDialog={onOpenCustomAudience}
        />
        {!!specificUsersProfiles?.length && (
          <SpecificUsersList
            profiles={specificUsersProfiles}
            customUsers={customUsers}
            onSetActiveAudience={onSetActiveAudience}
          />
        )}
        <AudienceSelectionDialogFooter
          onCancelSelection={onCancelSelection}
          onSaveSelection={onSaveSelection}
          doneDisabled={!canDone}
        />
      </DialogContainer>
    </DialogModal>
  );
};
